import { AuthTokens } from 'aws-amplify/auth';

export interface Profile {
  prid: string;
  email: string;
  designation?: string;
  userPrincipalName: string;
  familyName: string;
  givenName: string;
  lastUpdate: string;
  groups: string[];
  role: UserRole | null;
}

export enum UserRole {
  ANY = 'ANY',
  ADMIN = 'ADMIN',
  TA_USER = 'TA_USER',
  LEADERSHIP_USER = 'LEADERSHIP_USER',
}

export interface AuthPayload {
  sub: string;
  firstname: string;
  lastname: string;
  email: string;
  email_verified: boolean;
  exp: number;
  picture?: string;
  groups: string[];
  adgroups: string[];
  prid: string;
}
export interface AuthSession {
  userId: string;
  payload: AuthPayload;
  session: AuthTokens;
}
